(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-announcement-bar]';

    const initialize = (root) => {
      if (root.announcementCountdownTimer) return;

      const countdown = root.querySelector('[data-announcement-countdown]');
      if (!countdown) return;

      const configuredHour = Number.parseInt(root.dataset.cutoffHour, 10);
      const cutoffHour = Number.isInteger(configuredHour) && configuredHour >= 0 && configuredHour <= 23
        ? configuredHour
        : 15;
      const template = root.dataset.countdownTemplate;
      if (!template) return;
      /* Liquid renders today's cutoff as an absolute epoch in the STORE's time zone. Without
         it the old local-time reading would count down to the visitor's own 3 PM. */
      const epochSeconds = Number.parseInt(root.dataset.cutoffEpoch, 10);
      const absoluteCutoff = Number.isInteger(epochSeconds) ? new Date(epochSeconds * 1000) : null;
      const cutoff = absoluteCutoff || (() => {
        const local = new Date();
        local.setHours(cutoffHour, 0, 0, 0);
        return local;
      })();
      const line = root.querySelector('[data-announcement-line]');
      const afterText = root.dataset.afterText;

      const tick = () => {
        let milliseconds = cutoff - new Date();
        /* Past the cutoff the bar stops counting and states the real situation instead of
           silently rolling over to tomorrow's number. */
        if (milliseconds <= 0 && absoluteCutoff) {
          window.clearInterval(root.announcementCountdownTimer);
          root.announcementCountdownTimer = null;
          if (line && afterText) line.textContent = afterText;
          return;
        }
        if (milliseconds < 0) milliseconds += 864e5;

        const hours = Math.floor(milliseconds / 36e5);
        const minutes = Math.floor(milliseconds % 36e5 / 6e4);
        countdown.textContent = template
          .replace('__HOURS__', String(hours))
          .replace('__MINUTES__', String(minutes));
      };

      tick();
      root.announcementCountdownTimer = window.setInterval(tick, 30000);
    };

    const initializeWithin = (scope) => {
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeWithin(document);

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((root) => {
        window.clearInterval(root.announcementCountdownTimer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-ribbon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-deals]';

    const removeExpiredDeals = (root) => {
      if (root.hasAttribute('data-deals-editor')) return;
      const now = Date.now();
      let removed = false;
      root.querySelectorAll('[data-deal-ends]').forEach((item) => {
        const ends = Number(item.getAttribute('data-deal-ends')) * 1000;
        if (ends > 0 && ends <= now) {
          item.remove();
          removed = true;
        }
      });
      if (!root.querySelector('[data-deal]')) {
        root.hidden = true;
        return;
      }
      if (removed) root.motionRailRefresh?.();
    };

    const syncWithin = (scope) => {
      if (scope.matches?.(rootSelector)) removeExpiredDeals(scope);
      scope.querySelectorAll?.(rootSelector).forEach(removeExpiredDeals);
    };

    const writeClipboard = async (text) => {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.insetBlockStart = '0';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (fallbackError) {
          copied = false;
        }
        field.remove();
        return copied;
      }
    };

    const announce = (root, message) => {
      const status = root.querySelector('[data-deals-status]');
      if (!status || !message) return;
      status.textContent = '';
      window.setTimeout(() => {
        status.textContent = message;
      }, 60);
    };

    const selectCode = (button) => {
      const valueId = button.getAttribute('aria-describedby');
      const value = valueId ? document.getElementById(valueId) : null;
      const selection = window.getSelection();
      if (!value || !selection) return;
      const range = document.createRange();
      range.selectNodeContents(value);
      selection.removeAllRanges();
      selection.addRange(range);
    };

    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-deal-copy]') : null;
      const root = button?.closest(rootSelector);
      const code = button?.dataset.dealCode || '';
      if (!button || !root || !code) return;

      const copied = await writeClipboard(code);
      if (button.isConnected) button.focus({ preventScroll: true });

      if (copied) {
        window.clearTimeout(button.dealCopiedTimer);
        button.setAttribute('data-copied', '');
        button.dealCopiedTimer = window.setTimeout(() => button.removeAttribute('data-copied'), 1600);
        announce(root, button.dataset.copySuccess);
      } else {
        selectCode(button);
        announce(root, button.dataset.copyError);
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element) || !event.target.matches('[data-deal]')) return;
      event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) syncWithin(document);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') syncWithin(document);
    });

    document.addEventListener('shopify:section:load', (event) => syncWithin(event.target));

    syncWithin(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.footer-section';

    const initialize = (root) => {
      if (root.footerAccordionCleanup) return;

      const mediaQuery = window.matchMedia('(max-width: 56.25em)');
      const entries = [...root.querySelectorAll('[data-footer-accordion]')]
        .map((container) => ({
          container,
          button: container.querySelector('[data-footer-accordion-toggle]'),
          panel: container.querySelector('[data-footer-accordion-panel]'),
          mobileOpen: false
        }))
        .filter(({ button, panel }) => button && panel);

      const applyEntryState = (entry, open) => {
        if (!open && entry.panel.contains(document.activeElement)) {
          entry.button.focus();
        }
        entry.container.classList.toggle('open', open);
        entry.button.setAttribute('aria-expanded', String(open));
        entry.panel.hidden = !open;
      };

      const synchronize = () => {
        if (mediaQuery.matches) {
          entries.forEach((entry) => {
            entry.button.removeAttribute('aria-disabled');
            entry.button.removeAttribute('tabindex');
            applyEntryState(entry, entry.mobileOpen);
          });
        } else {
          entries.forEach((entry) => {
            entry.container.classList.remove('open');
            entry.button.setAttribute('aria-expanded', 'true');
            entry.button.setAttribute('aria-disabled', 'true');
            entry.button.setAttribute('tabindex', '-1');
            entry.panel.hidden = false;
          });
        }

        root.setAttribute('data-footer-accordion-ready', '');
      };

      const clickHandlers = entries.map((entry) => {
        const handler = () => {
          if (!mediaQuery.matches) return;
          entry.mobileOpen = !entry.mobileOpen;
          applyEntryState(entry, entry.mobileOpen);
        };
        entry.button.addEventListener('click', handler);
        return handler;
      });

      const keydown = (event) => {
        if (
          !mediaQuery.matches
          || event.defaultPrevented
          || event.isComposing
          || event.altKey
          || event.ctrlKey
          || event.metaKey
          || event.shiftKey
        ) return;
        const buttonIndex = entries.findIndex(({ button }) => button === event.target);
        if (buttonIndex < 0) return;

        let nextIndex = -1;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (buttonIndex + 1) % entries.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = (buttonIndex - 1 + entries.length) % entries.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = entries.length - 1;
        }

        if (nextIndex < 0) return;
        event.preventDefault();
        entries[nextIndex].button.focus();
      };

      entries.forEach(({ button }) => button.addEventListener('keydown', keydown));
      if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', synchronize);
      else mediaQuery.addListener(synchronize);
      synchronize();

      root.footerAccordionCleanup = () => {
        entries.forEach((entry, index) => {
          entry.button.removeEventListener('click', clickHandlers[index]);
          entry.button.removeEventListener('keydown', keydown);
          entry.button.removeAttribute('aria-disabled');
          entry.button.removeAttribute('tabindex');
          entry.button.setAttribute('aria-expanded', 'true');
          entry.panel.hidden = false;
          entry.container.classList.remove('open');
        });
        if (mediaQuery.removeEventListener) mediaQuery.removeEventListener('change', synchronize);
        else mediaQuery.removeListener(synchronize);
        root.removeAttribute('data-footer-accordion-ready');
        delete root.footerAccordionCleanup;
      };
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeWithin(document);

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches?.(selector)) event.target.footerAccordionCleanup?.();
      event.target.querySelectorAll(selector).forEach((root) => root.footerAccordionCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.header-section';

    const initialize = (root) => {
      if (root.headerCleanup) return;
      root.headerDrawerCleanup?.();

      const listeners = [];
      const listen = (target, type, handler, options) => {
        if (!target) return;
        target.addEventListener(type, handler, options);
        listeners.push(() => target.removeEventListener(type, handler, options));
      };

      const nav = root.querySelector('[data-header-nav]');
      const menu = root.querySelector('[data-header-menu]');
      const overflowItem = root.querySelector('[data-nav-overflow]');
      const overflowToggle = root.querySelector('[data-nav-overflow-toggle]');
      const overflowMenu = root.querySelector('[data-nav-overflow-menu]');
      const canonicalItems = menu
        ? Array.from(menu.children).filter((item) => item.matches('[data-nav-item]'))
        : [];

      const drawer = root.querySelector('[data-header-drawer]');
      const openButton = root.querySelector('[data-header-drawer-open]');
      const closeButton = root.querySelector('[data-header-drawer-close]');
      const scrim = root.querySelector('[data-header-drawer-scrim]');
      const headerLogo = root.querySelector('.header__logo');

      let disposed = false;
      let layoutFrame = 0;
      let drawerFocusFrame = 0;
      let layoutDeferred = false;
      let drawerReturnFocus = null;
      let resizeObserver = null;
      let suppressFocusOpenTarget = null;
      let pointerFocusTarget = null;
      let pointerFocusClearTimer = 0;

      const focusWithoutOpening = (target) => {
        if (!(target instanceof HTMLElement) || document.activeElement === target) return;
        suppressFocusOpenTarget = target;
        target.focus({ preventScroll: true });
        queueMicrotask(() => {
          if (suppressFocusOpenTarget === target) suppressFocusOpenTarget = null;
        });
      };

      const updateSubmenu = (item, open, returnFocus = false) => {
        const toggle = item?.querySelector('[data-nav-submenu-toggle]');
        if (!toggle) return;
        const submenu = Array.from(item.children).find((child) => child.matches('.header__drop'));
        if (!open && returnFocus && submenu?.contains(document.activeElement)) {
          focusWithoutOpening(toggle);
        }
        item.classList.toggle('is-submenu-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      };

      const closeSubmenus = (except = null, returnFocus = false) => {
        canonicalItems.forEach((item) => {
          if (item !== except) updateSubmenu(item, false, returnFocus);
        });
      };

      const openSubmenu = (item) => {
        closeSubmenus(item);
        updateSubmenu(item, true);
      };

      const closeMore = (returnFocus = false) => {
        if (!overflowItem || !overflowToggle || !overflowMenu) return;
        const activeElement = document.activeElement;
        const focusWasInside = activeElement instanceof Element && overflowItem.contains(activeElement);
        overflowItem.classList.remove('is-open');
        overflowToggle.setAttribute('aria-expanded', 'false');
        overflowMenu.hidden = true;
        canonicalItems.forEach((item) => {
          if (overflowMenu.contains(item)) updateSubmenu(item, false);
        });
        if (returnFocus && focusWasInside && overflowToggle.isConnected && !overflowItem.hidden) {
          focusWithoutOpening(overflowToggle);
        }
      };

      const openMore = () => {
        if (!overflowItem || !overflowToggle || !overflowMenu || overflowItem.hidden) return;
        closeSubmenus();
        overflowItem.classList.add('is-open');
        overflowToggle.setAttribute('aria-expanded', 'true');
        overflowMenu.hidden = false;
      };

      const restoreCanonicalOrder = () => {
        if (!menu || !overflowItem) return;
        canonicalItems.forEach((item) => menu.insertBefore(item, overflowItem));
      };

      const alignTopLevelSubmenus = () => {
        if (!menu) return;
        const viewportWidth = document.documentElement.clientWidth;
        const gutter = 8;
        canonicalItems.forEach((item) => {
          const submenu = Array.from(item.children).find((child) => child.matches('.header__drop'));
          if (!submenu) return;
          submenu.style.removeProperty('--submenu-shift-x');
          if (item.parentElement !== menu || viewportWidth <= 0) return;

          item.classList.add('is-submenu-measuring');
          const rect = submenu.getBoundingClientRect();
          let shift = rect.left < gutter ? gutter - rect.left : 0;
          if (rect.right + shift > viewportWidth - gutter) {
            shift += viewportWidth - gutter - (rect.right + shift);
          }
          if (Math.abs(shift) > 0.5) {
            submenu.style.setProperty('--submenu-shift-x', String(shift) + 'px');
          }
          item.classList.remove('is-submenu-measuring');
        });
      };

      const performLayout = () => {
        layoutFrame = 0;
        if (disposed || !nav || !menu || !overflowItem || !overflowToggle || !overflowMenu) return;

        const activeElement = document.activeElement;
        if (
          activeElement instanceof Element
          && nav.contains(activeElement)
        ) {
          layoutDeferred = true;
          return;
        }

        layoutDeferred = false;
        closeMore();
        closeSubmenus();
        restoreCanonicalOrder();
        overflowItem.hidden = true;
        overflowItem.classList.remove('has-active');
        overflowMenu.hidden = true;
        menu.removeAttribute('data-nav-overflow-ready');

        if (canonicalItems.length === 0 || menu.clientWidth <= 0) return;

        menu.setAttribute('data-nav-overflow-ready', '');
        const styles = getComputedStyle(menu);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const availableWidth = menu.clientWidth;
        const widths = canonicalItems.map((item) => item.getBoundingClientRect().width);
        const allItemsWidth = widths.reduce((total, width) => total + width, 0)
          + gap * Math.max(0, widths.length - 1);

        if (allItemsWidth <= availableWidth + 0.5) {
          alignTopLevelSubmenus();
          return;
        }

        overflowItem.hidden = false;
        const moreWidth = overflowItem.getBoundingClientRect().width;
        if (moreWidth > availableWidth + 0.5) {
          overflowItem.hidden = true;
          menu.removeAttribute('data-nav-overflow-ready');
          alignTopLevelSubmenus();
          return;
        }

        let keptCount = widths.length;
        let keptWidth = widths.reduce((total, width) => total + width, 0);
        while (keptCount > 0 && keptWidth + moreWidth + gap * keptCount > availableWidth + 0.5) {
          keptCount -= 1;
          keptWidth -= widths[keptCount];
        }

        canonicalItems.slice(keptCount).forEach((item) => overflowMenu.append(item));
        const hasActiveItem = Array.from(overflowMenu.children).some((item) => (
          item.querySelector('.active, [aria-current="page"]')
        ));
        overflowItem.classList.toggle('has-active', hasActiveItem);
        alignTopLevelSubmenus();
      };

      const scheduleLayout = () => {
        if (disposed || layoutFrame) return;
        layoutFrame = requestAnimationFrame(performLayout);
      };

      const handleNavClick = (event) => {
        if (pointerFocusClearTimer) window.clearTimeout(pointerFocusClearTimer);
        pointerFocusClearTimer = 0;
        pointerFocusTarget = null;
        if (!(event.target instanceof Element)) return;

        const moreButton = event.target.closest('[data-nav-overflow-toggle]');
        if (moreButton && overflowItem?.contains(moreButton)) {
          event.preventDefault();
          if (overflowItem.classList.contains('is-open')) closeMore();
          else openMore();
          return;
        }

        const submenuButton = event.target.closest('[data-nav-submenu-toggle]');
        const item = submenuButton?.closest('[data-nav-item]');
        if (!submenuButton || !item || !nav?.contains(item)) return;
        event.preventDefault();
        if (item.classList.contains('is-submenu-open')) updateSubmenu(item, false);
        else openSubmenu(item);
      };

      const handleNavFocusOut = () => {
        queueMicrotask(() => {
          if (disposed) return;
          const activeElement = document.activeElement;
          canonicalItems.forEach((item) => {
            if (!(activeElement instanceof Element) || !item.contains(activeElement)) {
              updateSubmenu(item, false);
            }
          });
          if (
            overflowItem?.classList.contains('is-open')
            && (!(activeElement instanceof Element) || !overflowItem.contains(activeElement))
          ) {
            closeMore();
          }
          if (layoutDeferred && (!(activeElement instanceof Element) || !nav?.contains(activeElement))) {
            scheduleLayout();
          }
        });
      };

      const handleNavFocusIn = (event) => {
        if (!(event.target instanceof Element)) return;
        if (pointerFocusTarget?.contains(event.target)) return;
        if (suppressFocusOpenTarget === event.target) {
          suppressFocusOpenTarget = null;
          return;
        }

        const relatedTarget = event.relatedTarget instanceof Node ? event.relatedTarget : null;
        if (
          overflowItem?.contains(event.target)
          && (!relatedTarget || !overflowItem.contains(relatedTarget))
        ) {
          openMore();
        }

        const item = event.target.closest('[data-nav-item]');
        if (!item || !nav?.contains(item) || (relatedTarget && item.contains(relatedTarget))) return;
        if (item.querySelector('[data-nav-submenu-toggle]')) openSubmenu(item);
      };

      /* Hovering a top-level item opens its submenu. The CSS hover fallback stops applying the
         moment the overflow measurement marks the menu ready, so without this listener a mouse
         user could only reach the submenu through the small chevron or the keyboard - which is
         exactly the "the dropdown does not take me to the product pages" report. Touch is left
         to the chevron, so a tap on the parent still follows its own link. */
      const handleNavPointerOver = (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.pointerType === 'touch') return;
        if (!desktopQuery.matches) return;
        const item = event.target.closest('[data-nav-item]');
        if (!item || !nav?.contains(item)) return;
        if (item.querySelector('[data-nav-submenu-toggle]')) openSubmenu(item);
      };

      /* Leaving the whole bar closes what the pointer opened; moving between items or down into
         an open submenu stays inside nav, so the panel does not flicker. */
      const handleNavPointerLeave = (event) => {
        if (event.pointerType === 'touch') return;
        if (!desktopQuery.matches) return;
        const to = event.relatedTarget instanceof Node ? event.relatedTarget : null;
        if (to && nav?.contains(to)) return;
        closeSubmenus();
      };

      const handleNavPointerDown = (event) => {
        if (!(event.target instanceof Element)) return;
        if (pointerFocusClearTimer) window.clearTimeout(pointerFocusClearTimer);
        pointerFocusTarget = event.target.closest('a, button, [tabindex]');
        pointerFocusClearTimer = window.setTimeout(() => {
          pointerFocusClearTimer = 0;
          pointerFocusTarget = null;
        }, 1000);
      };

      const schedulePointerFocusClear = () => {
        if (pointerFocusClearTimer) window.clearTimeout(pointerFocusClearTimer);
        pointerFocusClearTimer = window.setTimeout(() => {
          pointerFocusClearTimer = 0;
          pointerFocusTarget = null;
        }, 500);
      };

      const clearPointerFocus = () => {
        if (pointerFocusClearTimer) window.clearTimeout(pointerFocusClearTimer);
        pointerFocusClearTimer = 0;
        pointerFocusTarget = null;
      };

      const handleOutsidePointer = (event) => {
        if (!(event.target instanceof Node) || nav?.contains(event.target)) return;
        closeMore(true);
        closeSubmenus(null, true);
      };

      const focusableDrawerElements = () => {
        if (!drawer) return [];
        return Array.from(drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.getClientRects().length > 0);
      };

      const drawerIsOpen = () => Boolean(drawer?.classList.contains('open'));

      const closeDrawer = (returnFocus = false) => {
        if (!drawer || !openButton) return;
        if (drawerFocusFrame) cancelAnimationFrame(drawerFocusFrame);
        drawerFocusFrame = 0;

        const activeElement = document.activeElement;
        if (activeElement instanceof Element && drawer.contains(activeElement)) {
          const preferredTarget = returnFocus && drawerReturnFocus instanceof HTMLElement
            ? drawerReturnFocus
            : openButton;
          const focusTarget = preferredTarget?.isConnected && preferredTarget.getClientRects().length > 0
            ? preferredTarget
            : headerLogo;
          focusTarget?.focus({ preventScroll: true });
        }

        drawer.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('header-drawer-open');
        drawerReturnFocus = null;
      };

      const openDrawer = () => {
        if (!drawer || !openButton || !closeButton) return;
        document.dispatchEvent(new CustomEvent('depot:header-drawer-open'));
        closeMore();
        closeSubmenus();
        drawerReturnFocus = document.activeElement instanceof HTMLElement
          ? document.activeElement
          : openButton;
        drawer.removeAttribute('inert');
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('header-drawer-open');
        drawerFocusFrame = requestAnimationFrame(() => {
          drawerFocusFrame = 0;
          if (drawerIsOpen()) closeButton.focus({ preventScroll: true });
        });
      };

      const handleKeydown = (event) => {
        if (drawerIsOpen()) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDrawer(true);
            return;
          }
          if (event.key === 'Tab') {
            const focusable = focusableDrawerElements();
            if (focusable.length === 0) {
              event.preventDefault();
              return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
          return;
        }

        if (
          !event.repeat
          && !event.defaultPrevented
          && !event.isComposing
          && !event.altKey
          && !event.ctrlKey
          && !event.metaKey
          && !event.shiftKey
          && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')
          && event.target instanceof Element
        ) {
          const disclosure = event.target.closest(
            '[data-nav-overflow-toggle], [data-nav-submenu-toggle]'
          );
          if (disclosure && nav?.contains(disclosure)) {
            event.preventDefault();
            disclosure.click();
            return;
          }
        }

        if (event.key !== 'Escape' || !(document.activeElement instanceof Element)) return;
        const activeItem = document.activeElement.closest('[data-nav-item]');
        if (activeItem?.classList.contains('is-submenu-open')) {
          event.preventDefault();
          updateSubmenu(activeItem, false);
          focusWithoutOpening(activeItem.querySelector('[data-nav-submenu-toggle]'));
          return;
        }
        if (overflowItem?.classList.contains('is-open')) {
          event.preventDefault();
          closeMore(true);
        }
      };

      const desktopQuery = window.matchMedia('(min-width: 45.0625em)');
      const handleBreakpointChange = () => {
        closeMore(true);
        closeSubmenus(null, true);
        if (desktopQuery.matches) closeDrawer();
        scheduleLayout();
      };

      listen(nav, 'click', handleNavClick);
      listen(nav, 'focusin', handleNavFocusIn);
      listen(nav, 'focusout', handleNavFocusOut);
      listen(nav, 'pointerover', handleNavPointerOver);
      listen(nav, 'pointerleave', handleNavPointerLeave);
      listen(nav, 'pointerdown', handleNavPointerDown, true);
      listen(nav, 'pointerup', schedulePointerFocusClear, true);
      listen(nav, 'pointercancel', clearPointerFocus, true);
      listen(document, 'pointerdown', handleOutsidePointer);
      listen(root, 'keydown', handleKeydown);
      listen(openButton, 'click', openDrawer);
      listen(closeButton, 'click', () => closeDrawer(true));
      listen(scrim, 'click', () => closeDrawer(true));
      listen(window, 'resize', scheduleLayout, { passive: true });
      listen(window, 'orientationchange', handleBreakpointChange, { passive: true });
      listen(window, 'pageshow', scheduleLayout);
      listen(desktopQuery, 'change', handleBreakpointChange);

      if ('ResizeObserver' in window && menu?.parentElement) {
        resizeObserver = new ResizeObserver(scheduleLayout);
        resizeObserver.observe(menu.parentElement);
      }

      if (document.fonts) {
        document.fonts.ready.then(() => {
          if (!disposed) scheduleLayout();
        });
        listen(document.fonts, 'loadingdone', scheduleLayout);
      }

      root.headerCleanup = () => {
        disposed = true;
        if (layoutFrame) cancelAnimationFrame(layoutFrame);
        if (drawerFocusFrame) cancelAnimationFrame(drawerFocusFrame);
        if (pointerFocusClearTimer) window.clearTimeout(pointerFocusClearTimer);
        resizeObserver?.disconnect();
        suppressFocusOpenTarget = null;
        pointerFocusTarget = null;
        pointerFocusClearTimer = 0;
        listeners.splice(0).forEach((removeListener) => removeListener());
        closeMore();
        closeSubmenus();
        closeDrawer();
        restoreCanonicalOrder();
        canonicalItems.forEach((item) => {
          Array.from(item.children).find((child) => child.matches('.header__drop'))
            ?.style.removeProperty('--submenu-shift-x');
        });
        menu?.removeAttribute('data-nav-overflow-ready');
        if (overflowItem) {
          overflowItem.hidden = true;
          overflowItem.classList.remove('has-active');
        }
        delete root.headerCleanup;
      };

      scheduleLayout();
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeWithin(document);

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches?.(selector)) event.target.headerCleanup?.();
      event.target.querySelectorAll(selector).forEach((root) => root.headerCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const row = event.target.closest('[data-order-row-url]');
      if (!row || event.target.closest('a, button, input, select, textarea')) return;
      window.location.assign(row.dataset.orderRowUrl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupCountrySelector = (countrySelect) => {
      if (countrySelect.dataset.addressReady === 'true') return;

      const form = countrySelect.closest('form');
      const provinceSelect = form && form.querySelector('[data-address-province]');
      const provinceField = provinceSelect && provinceSelect.closest('[data-address-province-field]');

      if (!provinceSelect || !provinceField) return;

      const selectDefault = (select, defaultValue) => {
        if (!defaultValue) return;

        Array.from(select.options).some((option) => {
          if (option.value === defaultValue || option.text === defaultValue) {
            option.selected = true;
            return true;
          }
          return false;
        });
      };

      const updateProvinces = () => {
        let provinces = [];
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];

        try {
          provinces = JSON.parse((selectedOption && selectedOption.dataset.provinces) || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.replaceChildren();

        provinces.forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          provinceSelect.append(option);
        });

        provinceField.hidden = provinces.length === 0;
        provinceSelect.disabled = provinces.length === 0;
        selectDefault(provinceSelect, provinceSelect.dataset.default);
      };

      selectDefault(countrySelect, countrySelect.dataset.default);
      updateProvinces();
      countrySelect.addEventListener('change', updateProvinces);
      countrySelect.dataset.addressReady = 'true';
    };

    const setup = (scope = document) => {
      scope.querySelectorAll('[data-address-country]').forEach(setupCountrySelector);
    };

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-address-close]');
      if (!closeButton) return;

      const details = closeButton.closest('details');
      if (details) {
        const summary = details.querySelector(':scope > summary');
        details.open = false;
        summary?.focus({ preventScroll: true });
      }
    });

    document.addEventListener('submit', (event) => {
      const deleteForm = event.target.closest('[data-address-delete]');
      if (!deleteForm) return;

      if (!window.confirm(deleteForm.dataset.confirmMessage)) {
        event.preventDefault();
      }
    });

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
    setup();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-article-copy-link]');
    if (!trigger) return;

    event.preventDefault();
    const url = trigger.dataset.copyUrl || trigger.href;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).catch(() => {
        window.location.href = trigger.href;
      });
    } else {
      window.location.href = trigger.href;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-gift-card-copy]');
    if (!button) return;

    const code = button.dataset.giftCardCode || '';
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    const message = button.dataset.copySuccess || '';
    const status = button.closest('.giftwrap')?.querySelector('[data-gift-card-copy-status]');
    if (status) status.textContent = message;
    if (message && typeof window.depotToast === 'function') window.depotToast(message);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusPanelHeading = (section, recover) => {
      const selector = recover ? '.authcard--recover h2' : '.authcard--login h2';
      requestAnimationFrame(() => section?.querySelector(selector)?.focus({ preventScroll: true }));
    };

    const setRecoveryView = (section, recover, moveFocus = true) => {
      const recoverCard = section?.querySelector('.authcard--recover');
      if (!recoverCard) return;
      recoverCard.classList.toggle('is-active', recover);
      if (moveFocus) focusPanelHeading(section, recover);
    };

    document.addEventListener('click', (event) => {
      const openLink = event.target.closest('[data-recover-open]');
      const cancelLink = event.target.closest('[data-recover-cancel]');
      if (!openLink && !cancelLink) return;

      const source = openLink || cancelLink;
      const section = source.closest('.main-login-section') || source.closest('.shopify-section');
      setRecoveryView(section, Boolean(openLink));
    });

    window.addEventListener('hashchange', () => {
      document.querySelectorAll('.main-login-section').forEach((section) => {
        const recover = window.location.hash === '#RecoverPassword';
        setRecoveryView(section, recover);
      });
    });

    document.querySelectorAll('.main-login-section').forEach((section) => {
      const serverRecovery = section.querySelector('.authcard--recover')?.classList.contains('is-active');
      const hashRecovery = window.location.hash === '#RecoverPassword';
      setRecoveryView(section, Boolean(serverRecovery || hashRecovery), false);
      if (serverRecovery || hashRecovery) focusPanelHeading(section, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-order-reorder]');
      if (!button || button.disabled) return;

      const section = button.closest('.main-order-section') || button.closest('.shopify-section');
      const dataNode = section && section.querySelector('[data-order-reorder-items]');
      if (!dataNode) return;

      let items = [];
      try {
        items = JSON.parse(dataNode.textContent);
      } catch (error) {
        items = [];
      }

      if (!items.length) return;

      button.disabled = true;

      try {
        const response = await fetch(button.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('reorder_failed');

        if (window.depotToast) window.depotToast(button.dataset.successMessage);
        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        button.disabled = false;
        if (window.depotToast) {
          window.depotToast(button.dataset.errorMessage);
        } else {
          window.alert(button.dataset.errorMessage);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
